export enum ESidebarState {
  open = 0,
  closed = 1
}
